// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"JY-z","subtitle":"KY-z","wrapper":"LY-z","leftArrow":"MY-z","rightArrow":"NY-z"};